export default "__VITE_ASSET__D_Pm17ru__"